<app-page-header [heading]="'Sales Report'" [icon]="'fa-balance-scale'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="row">
    <div class="form-group col-lg-4">
      <label>From</label>
      <input (ngModelChange)="fromdate = $event" [max]="getToday()" [ngModel]="fromdate | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">

    </div>
    <div class="form-group col-lg-4">
      <label>To</label>
      <input (ngModelChange)="todate = $event" [max]="getToday()" [ngModel]="todate | date:'yyyy-MM-dd'"
             class="form-control " id="todate" name="todate" type="date">
    </div>
    <div class="form-group col-lg-4">
      <label></label><br>
      <button (click)="listSaleReport();" class="btn btn-info btn-sm ng-star-inserted" type="button">
        &nbsp;Search&nbsp;
      </button>

    </div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>

    <div class="text-right col-lg-12 pull-right">
      <button *ngIf="(sale_data | json) != '[]'" (click)="exportAsXLSX()" class="btn btn-info btn-sm ng-star-inserted" title="Export as XLSX">Export to
        XLSX&nbsp;<i class="fa fa-file-excel-o"></i></button>&nbsp;
      <app-report-pdf *ngIf="(sale_data | json) != '[]'" targetId="printReport" fileName="Sales_Report.pdf" titleName="SALES REPORT"></app-report-pdf>
    </div>
    <div class="clearfix"></div>
    <div class=" col-12" id="printReport">
      <table #table class="table tbl table-bordered" style="background-color: #f3f8fd">
        <thead>
        <tr class="text-center">
          <th width="5%">Sl</th>
          <th class="text-left">Item</th>
          <th width="10%" class="text-right">Quantity</th>
          <th width="20%" class="text-right">Amount</th>
        </tr>
        <tr *ngIf="(sale_data | json) == '[]'">
          <td class="text-center" colspan="7">No data to list</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let sale of sale_data;let i=index">
          <td class="text-center">{{ i + 1 }}</td>
          <td> {{ sale.ItemCode }} - {{ sale.Item }}</td>
          <td class="text-right">{{ sale.Quantity }}</td>
          <td class="text-right">{{ sale.Amount }}</td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th colspan="3" class="text-right">Total Amount</th>
          <th class="text-right">{{ total_amount | number : '1.2-2' }}</th>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>



